// import { palette } from '@/theme/constants';
// import { Box, LinearProgress, Typography } from '@mui/material';
// import { forwardRef, useEffect, useState } from 'react';
// import ReactPlayer from 'react-player';
// import { MuiIconButton } from '@/components';
// import style from './styles.module.scss';

// export const VideoPlayer = forwardRef<ReactPlayer, any>(
//   (
//     {
//       url,
//       containerHeight = '22rem',
//       height = '21.8125rem',
//       disabledVideo,
//       playingg,
//       borderRadius = '1.25rem',
//       isSelected,
//       cover,
//       hideControls= 'false',
//     }: any,
//     ref,
//   ) => {
//     const [showControls, setShowControls] = useState<boolean>(false);
//     const [showHover, setShowHover] = useState<boolean>(false);
//     const [playing, setPlaying] = useState<boolean>(false);
//     const [duration, setDuration] = useState<number>(0);
//     const [playedSeconds, setPlayedSeconds] = useState<number>(0);
//     const [seeking, setSeeking] = useState<boolean>(false);

//     const playMedia = (event: any) => {
//       if (event?.target?.alt === 'pause') return setPlaying(true);
//       if (event?.target?.localName === 'video') return setPlaying(true);
//     };

//     const pauseMedia = () => {
//       setPlaying(false);
//     };

//     const handleDuration = (duration: number) => {
//       setDuration(duration);
//     };

//     const handleProgress = (progress: { playedSeconds: number }) => {
//       if (!seeking) {
//         setPlayedSeconds(progress.playedSeconds);
//       }
//     };

//     const restartVideo = () => {
//       if (ref && 'current' in ref && ref.current) {
//         ref.current.seekTo(0);
//         setPlaying(true);
//       }
//     };

//     const pad = (num: number, size: number): string => num.toString().padStart(size, '0');

//     const formatTime = (seconds: number): string => {
//       const hours = Math.floor(seconds / 3600);
//       const minutes = Math.floor((seconds % 3600) / 60);
//       const secondsLeft = Math.floor(seconds % 60);

//       if (hours > 0) {
//         return `${pad(hours, 2)}:${pad(minutes, 2)}:${pad(secondsLeft, 2)}`;
//       } else {
//         return `${pad(minutes, 2)}:${pad(secondsLeft, 2)}`;
//       }
//     };

//     const handleSeek = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
//       const boundingRect = event.currentTarget.getBoundingClientRect();
//       const clickPosition = event.clientX - boundingRect.left;
//       const newPosition = (clickPosition / boundingRect.width) * duration;
//       if (ref && 'current' in ref && ref.current) {
//         ref.current.seekTo(newPosition);
//         setPlayedSeconds(newPosition);
//       }
//     };

//     const skipBackward = () => {
//       const newTime = Math.max(0, playedSeconds - 10);
//       if (ref && 'current' in ref && ref.current) {
//         ref.current.seekTo(newTime);
//         setPlayedSeconds(newTime);
//         setPlaying(true);
//       }
//     };

//     useEffect(() => {
//       setPlaying(false);
//     }, [playingg]);
//     const skipForward = () => {
//       const newTime = Math.min(playedSeconds + 10, duration);
//       if (ref && 'current' in ref && ref.current) {
//         ref.current.seekTo(newTime);
//         setPlayedSeconds(newTime);
//         setPlaying(true);
//       }
//     };

//     return (
//       <Box
//         borderRadius={borderRadius}
//         data-cy={'video-player'}
//         border={isSelected ? `2px solid ${palette.primary}` : 'none'}
//         width={'100%'}
//         position={'relative'}
//         onClick={(event) => (!disabledVideo ? (playing ? pauseMedia() : playMedia(event)) : null)}
//         onMouseEnter={() => setShowHover(true)}
//         sx={{ cursor: 'pointer' }}
//         maxHeight={containerHeight}
//         height={containerHeight}>
//         <Box height={containerHeight}>
//           <ReactPlayer
//             width={'100%'}
//             ref={ref}
//             onClickPreview={() => (!disabledVideo ? playMedia(event) : null)}
//             playing={playing}
//             controls={false}
//             onStart={() => setShowControls(true)}
//             onDuration={handleDuration}
//             onProgress={handleProgress}
//             height={height}
//             className={cover ? style._player : ''}
//             style={{
//               borderRadius: '1.25rem',
//               overflow: 'hidden',
//             }}
//             url={url}
//           />
//         </Box>
//         {/* Control elements */}

//     {!hideControls && (
//         <Box
//           display={'flex'}
//           position={'absolute'}
//           paddingTop={'0.5rem'}
//           bgcolor={palette.backgroundOpacity}
//           bottom={'0.5rem'}
//           left={0}
//           right={0}
//           flexDirection={'column'}>
//           <Box
//             width={'100%'}
//             padding={'0 0.5rem'}
//             display={'flex'}
//             justifyContent={'space-between'}
//             alignItems={'center'}>
//             <Box width={'10%'}>
//               <Typography variant='subtitle2'>{formatTime(playedSeconds)}</Typography>
//             </Box>
//             <Box width={'75%'} margin={'0 auto'}>
//               <LinearProgress
//                 variant='determinate'
//                 onClick={handleSeek}
//                 sx={{ height: '0.5rem' }}
//                 value={(playedSeconds / duration) * 100}
//                 color='secondary'
//               />
//             </Box>
//             <Box width={'10%'}>
//               <Typography variant='subtitle2' textAlign={'right'}>
//                 {formatTime(duration)}
//               </Typography>
//             </Box>
//           </Box>
//           <Box
//             display={'flex'}
//             margin={'1rem auto 0 auto'}
//             justifyContent={'space-between'}
//             alignItems={'center'}
//             width={'50%'}>
//             <MuiIconButton
//               icon='/icons/restart'
//               altIcon='restart'
//               background={'transparent'}
//               iconHeight={20}
//               iconWidth={20}
//               method={() => restartVideo()}
//             />
//             <MuiIconButton
//               icon='/icons/play-track-left'
//               altIcon='play-track-left'
//               background={'transparent'}
//               iconHeight={20}
//               iconWidth={20}
//               method={() => skipBackward()}
//             />
//             <MuiIconButton
//               icon={!playing ? '/icons/play' : '/icons/pause'}
//               altIcon='pause'
//               background={'transparent'}
//               iconHeight={38}
//               iconWidth={38}
//               method={(event) => (playing ? pauseMedia() : playMedia(event))}
//             />
//             <MuiIconButton
//               icon='/icons/play-track-right'
//               altIcon='play-track-right'
//               background={'transparent'}
//               iconHeight={20}
//               iconWidth={20}
//               method={() => skipForward()}
//             />
//             <Box width={32} height={32} />
//           </Box>
//         </Box>
//     )}
//       </Box>
//     );
//   },
// );

// VideoPlayer.displayName = 'VideoPlayer';

import { palette } from '@/theme/constants';
import { Box, CircularProgress, LinearProgress, Typography } from '@mui/material';
import { forwardRef, useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { MuiIconButton } from '@/components';
import style from './styles.module.scss';

export const VideoPlayer = forwardRef<ReactPlayer, any>(
  (
    {
      url,
      containerHeight = '22rem',
      height = '21.8125rem',
      isThumbnail = false,
      disabledVideo,
      playingg,
      borderRadius = '1.25rem',
      isSelected,
      cover,
      hideControls = 'false',
    }: any,
    ref: any,
  ) => {
    const [showControls, setShowControls] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(true);

    const [showHover, setShowHover] = useState<boolean>(false);
    const [playing, setPlaying] = useState<boolean>(false);
    const [duration, setDuration] = useState<number>(0);
    const [playedSeconds, setPlayedSeconds] = useState<number>(0);
    const [seeking, setSeeking] = useState<boolean>(false);
    const [isFullscreen, setIsFullscreen] = useState<boolean>(false);

    const containerRef = useRef<HTMLDivElement>(null);

    const playMedia = (event: any) => {
      if (event?.target?.alt === 'pause') return setPlaying(true);
      if (event?.target?.localName === 'video') return setPlaying(true);
    };

    const pauseMedia = () => {
      setPlaying(false);
    };

    const handleDuration = (duration: number) => {
      setDuration(duration);
    };

    const handleProgress = (progress: { playedSeconds: number }) => {
      if (!seeking) {
        setPlayedSeconds(progress.playedSeconds);
      }
    };

    const restartVideo = () => {
      if (ref && 'current' in ref && ref.current) {
           ref.current.seekTo(0, 'seconds');
        setPlaying(true);
      }
    };

    const pad = (num: number, size: number): string => num.toString().padStart(size, '0');

    const formatTime = (seconds: number): string => {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secondsLeft = Math.floor(seconds % 60);

      if (hours > 0) {
        return `${pad(hours, 2)}:${pad(minutes, 2)}:${pad(secondsLeft, 2)}`;
      } else {
        return `${pad(minutes, 2)}:${pad(secondsLeft, 2)}`;
      }
    };

    const handleSeek = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      const boundingRect = event.currentTarget.getBoundingClientRect();
      const clickPosition = event.clientX - boundingRect.left;
      const newPosition = (clickPosition / boundingRect.width) * duration;
      if (ref && 'current' in ref && ref.current) {
        ref.current.seekTo(newPosition);
        setPlayedSeconds(newPosition);
      }
    };

    const skipBackward = () => {
      const newTime = Math.max(0, playedSeconds - 10);
      if (ref && 'current' in ref && ref.current) {
        ref.current.seekTo(newTime);
        setPlayedSeconds(newTime);
        setPlaying(true);
      }
    };

    const skipForward = () => {
      const newTime = Math.min(playedSeconds + 10, duration);
      if (ref && 'current' in ref && ref.current) {
        ref.current.seekTo(newTime);
        setPlayedSeconds(newTime);
        setPlaying(true);
      }
    };

    const toggleFullscreen = () => {
      const el = containerRef.current;
      if (!el) return;

      if (!document.fullscreenElement) {
        el.requestFullscreen?.().then(() => setIsFullscreen(true));
      } else {
        document.exitFullscreen?.().then(() => setIsFullscreen(false));
      }
    };

    useEffect(() => {
      const onFullscreenChange = () => {
        setIsFullscreen(!!document.fullscreenElement);
      };
      document.addEventListener('fullscreenchange', onFullscreenChange);
      return () => {
        document.removeEventListener('fullscreenchange', onFullscreenChange);
      };
    }, []);

    // useEffect(() => {
    //   setPlaying(false);
    // }, [playingg]);

    useEffect(() => {
      if (playingg && !isThumbnail) {
        // only start if parent said “play” and this isn’t a thumbnail
        setPlaying(true);
      } else {
        // otherwise, always pause
        setPlaying(false);
      }
    }, [playingg, isThumbnail]);

    return (
      <Box
        ref={containerRef}
        borderRadius={borderRadius}
        data-cy={'video-player'}
        border={isSelected ? `2px solid ${palette.primary}` : 'none'}
        position={'relative'}
        onClick={(event) => (!disabledVideo ? (playing ? pauseMedia() : playMedia(event)) : null)}
        onMouseEnter={() => setShowHover(true)}
        sx={{ cursor: 'pointer' }}
        height={isFullscreen ? '100dvh' : containerHeight}
        width={isFullscreen ? '100vw' : '100%'}>
        <Box height={containerHeight}>
          <ReactPlayer
            width={isFullscreen ? '100vw' : '100%'}
            height={isFullscreen ? '100dvh' : height}
            ref={ref}
            onClickPreview={() => (!disabledVideo ? playMedia(event) : null)}
            playing={playing}
            onBuffer={() => {
              setIsLoading(true);
            }}
            onBufferEnd={() => {
              setIsLoading(false);
            }}
            onReady={() => {
              setIsLoading(false);
            }}
            onEnded={() => setPlaying(false)}
            controls={false}
            onStart={() => {
              setShowControls(true);
              setIsLoading(false);
            }}
            onDuration={handleDuration}
            onProgress={handleProgress}

            // height={height}
            className={cover ? style._player : ''}
            style={{
              borderRadius: '0',
              overflow: 'hidden',
            }}
            url={url}
            position='relative'
            zIndex={3}
          />
        </Box>

        {isLoading && (
          <Box
            position='absolute'
            top={0}
            left={0}
            width='100%'
            height='100%'
            display='flex'
            justifyContent='center'
            alignItems='center'
            // bgcolor='rgba(0, 0, 0, 0.4)'
            zIndex={9}>
            <CircularProgress color='secondary' />
          </Box>
        )}
        {/* Controls */}
        {!hideControls && (
          <Box
            display={'flex'}
            position={'absolute'}
            paddingTop={'0.4rem'}
            bgcolor={palette.backgroundOpacity}
            bottom={'0.4rem'}
            left={0}
            right={0}
            flexDirection={'column'}>
            <Box
              width={'100%'}
              padding={'0 0.5rem'}
              display={'flex'}
              justifyContent={'space-between'}
              alignItems={'center'}>
              <Box width={'10%'}>
                <Typography variant='subtitle2'>{formatTime(playedSeconds)}</Typography>
              </Box>
              <Box width={'75%'} margin={'0 auto'}>
                <LinearProgress
                  variant='determinate'
                  onClick={handleSeek}
                  sx={{ height: '0.5rem' }}
                  value={(playedSeconds / duration) * 100}
                  color='secondary'
                />
              </Box>
              <Box width={'10%'}>
                <Typography variant='subtitle2' textAlign={'right'}>
                  {formatTime(duration)}
                </Typography>
              </Box>
            </Box>
            <Box
              display={'flex'}
              margin={'1rem auto 0 auto'}
              justifyContent={'space-between'}
              alignItems={'center'}
              width={'60%'}>
              <MuiIconButton
                icon='/icons/restart'
                altIcon='restart'
                background={'transparent'}
                iconHeight={20}
                iconWidth={20}
                method={() => restartVideo()}
              />
              <MuiIconButton
                icon='/icons/play-track-left'
                altIcon='play-track-left'
                background={'transparent'}
                iconHeight={20}
                iconWidth={20}
                method={() => skipBackward()}
              />
              <MuiIconButton
                icon={!playing ? '/icons/play' : '/icons/pause'}
                altIcon='pause'
                background={'transparent'}
                iconHeight={38}
                iconWidth={38}
                method={(event: any) => (playing ? pauseMedia() : playMedia(event))}
              />
              <MuiIconButton
                icon='/icons/play-track-right'
                altIcon='play-track-right'
                background={'transparent'}
                iconHeight={20}
                iconWidth={20}
                method={() => skipForward()}
              />
              <MuiIconButton
                // icon={isFullscreen ? '/icons/minimize' : '/icons/fullscreen'}
                // altIcon={isFullscreen ? 'minimize' : 'fullscreen'}
                // background={'transparent'}
                // iconHeight={20}
                // iconWidth={20}
                // method={toggleFullscreen}
              />
            </Box>
          </Box>
        )}
      </Box>
    );
  },
);

VideoPlayer.displayName = 'VideoPlayer';
